// extracted by mini-css-extract-plugin
export default {"cardGroup":"styles_cardGroup__3svsA"};